import { SubscriptionAddonDataFragment } from '@stigg-types/apiTypes';
import { Grid, Link, Text } from '@stigg-components';
import { t } from 'i18next';
import React from 'react';
import { useNavigation } from '../../../../../../../../navigation/useNavigation';
import { ChangeType, SubscriptionFutureUpdateRowContainer } from '../../SubscriptionFutureUpdateRowContainer';

type AddonQuantityUpdatedRowProps = {
  subscriptionAddon: SubscriptionAddonDataFragment;
  alertVariant?: boolean;
};

export function AddonRemovedRow({ subscriptionAddon, alertVariant }: AddonQuantityUpdatedRowProps) {
  const navigation = useNavigation();
  const { quantity, addon } = subscriptionAddon;

  return (
    <SubscriptionFutureUpdateRowContainer changeType={ChangeType.REMOVED}>
      <Grid alignItems="baseline" gap={1}>
        <Text.B2 color={alertVariant ? 'warning.content' : 'primary'}>
          {t('subscriptions.schedules.addonRemovePrefix')}
        </Text.B2>
        <Link
          variant="body2"
          onClick={() => {
            navigation.navigateTo(navigation.appRoutes.addonPage(addon.refId));
          }}>
          <Text.B2 $bold color={alertVariant ? 'warning.content' : undefined}>
            {addon.displayName}
          </Text.B2>
        </Link>
        <Text.B2 color={alertVariant ? 'warning.content' : 'primary'}>
          {t('subscriptions.schedules.addon')}
          {quantity > 1 && ` ${t('subscriptions.schedules.addonRemoveAllInstances')}`}
        </Text.B2>
      </Grid>
    </SubscriptionFutureUpdateRowContainer>
  );
}
